import React, { useRef, useEffect, useState } from 'react'

// import dynamic from 'next/dynamic'
// import produce from 'immer'

// import TextareaAutosize from 'react-textarea-autosize'
// import ReactMarkdown from 'react-markdown'

// import { Editor } from '@tiptap/core'
// import { defaultExtensions } from '@tiptap/starter-kit'
// import Highlight from '@tiptap/extension-highlight'
// import Typography from '@tiptap/extension-typography'
// import TaskList from '@tiptap/extension-task-list'
// import TaskItem from '@tiptap/extension-task-item'

// import Classnames from 'classnames'

// import { useEffectOnce } from 'react-use'

// import { BiHeading } from 'react-icons/bi'
// import { RiAddFill } from 'react-icons/ri'
// import {
//   MdFormatBold,
//   MdFormatItalic,
//   MdFormatClear,
//   MdFormatStrikethrough,
//   MdFormatListBulleted,
//   MdFormatListNumbered,
//   MdFormatQuote,
//   MdRemove,
//   MdDone,
// } from 'react-icons/md'

// const MdEditor = dynamic(() => import('react-markdown-editor-lite'), {
//   ssr: false
// });
// import 'react-markdown-editor-lite/lib/index.css';

// const ReactQuill = dynamic(() => import('react-quill'), { ssr: false })
// import 'react-quill/dist/quill.snow.css';

// import EditorJs from 'react-editor-js';

// import { Editor } from 'react-draft-wysiwyg';
// import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

// Import the Slate editor factory.
// import { createEditor } from 'slate'

// Import the Slate components and React plugin.
// import { Slate, Editable, withReact } from 'slate-react'

import { useRecoilState, useRecoilValue, useRecoilCallback } from 'recoil'
import { content, content_block } from '@/store/template/content'

// components
import Title from '@/components/onepager/sections/Title'

function RichText({ id, contentID, sectionData, wrapperId }) {
  // const [previewHTML, setPreviewHTML] = useState(false)

  const [getContent, setContent] = useRecoilState(content(contentID))

  // let editorTT = undefined
  // const [editorTipTap, setEditorTipTap] = useState()
  // const editorRef = useRef()

  // useEffectOnce(() => {
  //   setEditorTipTap(
  //     new Editor({
  //       element: editorRef.current,
  //       extensions: [
  //         ...defaultExtensions(),
  //         Highlight,
  //         Typography,
  //         TaskList,
  //         TaskItem,
  //       ],
  //       content: getContent.content,
  //       onUpdate() {
  //         const json = this.getJSON()
  //         console.log(JSON.stringify(json))
  //         const nextState = produce(getContent, draft => {
  //           draft.content = json
  //         })
  //         setContent(nextState)
  //       },
  //     })
  //   )
  // })

  // useEffect(() => {
  //   if (editorTT == undefined) {
  //     // console.log('Editor', Editor)
  //     // selectableJS = (await import('selectable.js')).default
  //     setEditorTipTap(
  //       new Editor({
  //         element: editorRef.current,
  //         extensions: [
  //           ...defaultExtensions(),
  //           Highlight,
  //           Typography,
  //           TaskList,
  //           TaskItem,
  //         ],
  //         content: '<p>Your content.</p>',
  //         onUpdate() {
  //           // const json = this.getJSON()
  //           // console.log('onUpdate()', json)
  //         },
  //       })
  //     )
  //     editorTT = '1'
  //   }
  // }, [])

  // const updateContent = e => {
  //   // console.log(e.target.value)

  //   const nextState = produce(getContent, draft => {
  //     draft.content = e.target.value
  //   })
  //   setContent(nextState)
  // }

  // const updateContentMD = data => {
  //   const nextState = produce(getContent, draft => {
  //     draft.content = data.text
  //   })
  //   setContent(nextState)
  // }

  return (
    <div>
      <Title
        id={id}
        title={sectionData.title}
        prompt={sectionData.prompt}
        wrapperId={wrapperId}
      />

      <div className="boxBody boxBodyTextEditor relative">
        {/* older display */}
        <div
          className="richTextStyles"
          dangerouslySetInnerHTML={{ __html: getContent.content }}
        ></div>
        {!getContent.content && (
          <div className="text-sm opacity-50">No content yet...</div>
        )}
      </div>
    </div>
  )
}

export default RichText
